import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=491a45ce&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a45ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('491a45ce')) {
      api.createRecord('491a45ce', component.options)
    } else {
      api.reload('491a45ce', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=491a45ce&scoped=true&", function () {
      api.rerender('491a45ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O1d7lCl53ceb/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports